import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./App.css";
import { ThemeProvider } from "./context/ThemeContext";
import { useDocumentLang } from "./hooks/useDocumentLang";
import ProsegLanding from "./components/prosegpay/ProsegLanding";
import { ProsegNav } from "./components/prosegpay/ProsegNav";
import { ProsegFooter } from "./components/prosegpay/ProsegFooter";
import Formsend from "./components/formsend";
import Message from "./components/message";
import Account from "./components/account";
import ForuJob from "./components/forujob";
import Foru from "./components/foru";
import ContratoPF from "./components/contratopf";
import ContratoPJ from "./components/contratopj";
import SecurityCiber from "./components/securityCiber";
import SecurityDados from "./components/securityDados";
import SecurityUses from "./components/securityUses";
import Ouvidoria from "./components/ouvidoria";
import Garantias from "./components/garantias";
import { AccountCancellation } from "./components/AccountCancellation";

const AppRoutes = () => (
  <>
    <ProsegNav />
    <Routes>
      <Route path="/" element={<ProsegLanding />} />
      <Route path="/workforus" element={<Formsend />} />
      <Route path="/message" element={<Message />} />
      <Route path="/account" element={<Account />} />
      <Route path="/forujob" element={<ForuJob />} />
      <Route path="/foru" element={<Foru />} />
      <Route path="/contratoPF" element={<ContratoPF />} />
      <Route path="/contratoPJ" element={<ContratoPJ />} />
      <Route path="/ciber-security" element={<SecurityCiber />} />
      <Route path="/dados-security" element={<SecurityDados />} />
      <Route path="/uses-security" element={<SecurityUses />} />
      <Route path="/ouvidoria" element={<Ouvidoria />} />
      <Route path="/garantias" element={<Garantias />} />
      <Route path="/cancelamento-de-conta" element={<AccountCancellation />} />
    </Routes>
    <ProsegFooter />
  </>
);

const App = () => {
  useDocumentLang();

  return (
    <div id="rootApp">
      <BrowserRouter>
        <ThemeProvider>
          <AppRoutes />
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
